
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
components: {
XHeader,
Group,
Cell,
Tabbar,
TabbarItem
},
data() {
return {
ebbinghausList: []
};
},
created() {
this.getData();
},
methods: {
getData() {
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadEbbinghausList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.ebbinghausList = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
clickEbbinghaus(item) {
if (item.icount <= 0) {
this.$vux.alert.show({
title: "科学记忆",
content: "该阶段没有记忆的题库！！"
});
return;
}

this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInEbbinghaus,
errvalue: item.iperiod
}
});
},
onInfo() {
this.$router.replace({ path: "/Ebbinghaus" });
}
}
};



// WEBPACK FOOTER //
// ./src/components/Memory.vue